import { toast } from "react-toastify";

export interface SidebarDisabledMessages {
  planNotAllowed: string;
  syncRequired: string;
  comingSoon: string;
  reportsNotAllowed: string;
}

export const showSidebarDisabledToast = (
  message: string | undefined,
  toastId: string
) => {
  if (!message?.trim()) return;

  toast.info(message, {
    autoClose: 3500,
    toastId,
  });
};
